import { removeToast, showToast } from '@/src/globalFunction';

import { invalidateInboxQueries } from '../../../../api/inbox';

export const refreshInbox = async () => {
  showToast('success', `Loading...`, 100000);
  await invalidateInboxQueries();

  removeToast();
};
